"use strict";
'use es6'; // TODO: remove labels or at least pass them through I18n

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  blog_post: {
    template_folder: 'blog',
    name: 'blog-post',
    api_slug: 'blog-posts',
    label: 'Blog Post',
    dashboard_slug: 'blog-posts',
    new_content_slug: 'new/blog-post',
    id: 3,
    generic_label: 'Blog',
    label_plural: 'Blog Posts',
    field_name: 'blog_post',
    slug_plural: 'blog-posts',
    slug_singular: 'blog-post'
  },
  1: {
    template_folder: 'landing_page',
    name: 'landing-page',
    api_slug: 'landing-pages',
    label: 'Landing Page',
    dashboard_slug: 'landing-pages',
    new_content_slug: 'new/landing-page',
    id: 1,
    generic_label: 'Page',
    label_plural: 'Landing Pages',
    field_name: 'landing_page',
    slug_plural: 'landing-pages',
    slug_singular: 'landing-page'
  },
  2: {
    template_folder: 'email',
    name: 'email',
    api_slug: 'emails',
    label: 'Email',
    dashboard_slug: 'email',
    new_content_slug: 'new/email',
    id: 2,
    generic_label: 'Email',
    label_plural: 'Email',
    field_name: 'email',
    slug_plural: 'email',
    slug_singular: 'email'
  },
  3: {
    template_folder: 'blog',
    name: 'blog-post',
    api_slug: 'blog-posts',
    label: 'Blog Post',
    dashboard_slug: 'blog-posts',
    new_content_slug: 'new/blog-post',
    id: 3,
    generic_label: 'Blog',
    label_plural: 'Blog Posts',
    field_name: 'blog_post',
    slug_plural: 'blog-posts',
    slug_singular: 'blog-post'
  },
  4: {
    template_folder: 'site_page',
    name: 'site-page',
    api_slug: 'site-pages',
    label: 'Website Page',
    dashboard_slug: 'site-pages',
    new_content_slug: 'new/site-page',
    id: 4,
    generic_label: 'Website Page',
    label_plural: 'Website Pages',
    field_name: 'site_page',
    slug_plural: 'site-pages',
    slug_singular: 'site-page'
  },
  5: {
    template_folder: 'legacy_page',
    name: 'legacy-page',
    api_slug: 'legacy-pages',
    label: 'Classic CMS Page',
    dashboard_slug: 'legacy-pages',
    new_content_slug: 'new/legacy-page',
    id: 5,
    generic_label: 'Classic CMS Page',
    label_plural: 'Classic CMS Pages',
    field_name: 'legacy_page',
    slug_plural: 'legacy-pages',
    slug_singular: 'legacy-page'
  },
  0: {
    template_folder: 'pages',
    name: 'unmapped',
    api_slug: 'unmappeds',
    label: 'Unmapped',
    dashboard_slug: 'unmappeds',
    new_content_slug: 'new/unmapped',
    id: 0,
    generic_label: 'System',
    label_plural: 'Unmappeds',
    field_name: 'unmapped',
    slug_plural: 'unmappeds',
    slug_singular: 'unmapped'
  },
  6: {
    template_folder: '',
    name: 'knowledge-article',
    api_slug: '',
    label: 'Knowledge Article',
    dashboard_slug: '',
    new_content_slug: '',
    id: 6,
    generic_label: '',
    label_plural: 'Knowledge Articles',
    field_name: 'knowledge_article',
    slug_plural: 'knowledge-article',
    slug_singular: 'knowledge-articles'
  },
  landing_page: {
    template_folder: 'landing_page',
    name: 'landing-page',
    api_slug: 'landing-pages',
    label: 'Landing Page',
    dashboard_slug: 'landing-pages',
    new_content_slug: 'new/landing-page',
    id: 1,
    generic_label: 'Page',
    label_plural: 'Landing Pages',
    field_name: 'landing_page',
    slug_plural: 'landing-pages',
    slug_singular: 'landing-page'
  },
  'site-page': {
    template_folder: 'site_page',
    name: 'site-page',
    api_slug: 'site-pages',
    label: 'Website Page',
    dashboard_slug: 'site-pages',
    new_content_slug: 'new/site-page',
    id: 4,
    generic_label: 'Website Page',
    label_plural: 'Website Pages',
    field_name: 'site_page',
    slug_plural: 'site-pages',
    slug_singular: 'site-page'
  },
  'landing-page': {
    template_folder: 'landing_page',
    name: 'landing-page',
    api_slug: 'landing-pages',
    label: 'Landing Page',
    dashboard_slug: 'landing-pages',
    new_content_slug: 'new/landing-page',
    id: 1,
    generic_label: 'Page',
    label_plural: 'Landing Pages',
    field_name: 'landing_page',
    slug_plural: 'landing-pages',
    slug_singular: 'landing-page'
  },
  legacy_page: {
    template_folder: 'legacy_page',
    name: 'legacy-page',
    api_slug: 'legacy-pages',
    label: 'Classic CMS Page',
    dashboard_slug: 'legacy-pages',
    new_content_slug: 'new/legacy-page',
    id: 5,
    generic_label: 'Classic CMS Page',
    label_plural: 'Classic CMS Pages',
    field_name: 'legacy_page',
    slug_plural: 'legacy-pages',
    slug_singular: 'legacy-page'
  },
  'legacy-page': {
    template_folder: 'legacy_page',
    name: 'legacy-page',
    api_slug: 'legacy-pages',
    label: 'Classic CMS Page',
    dashboard_slug: 'legacy-pages',
    new_content_slug: 'new/legacy-page',
    id: 5,
    generic_label: 'Classic CMS Page',
    label_plural: 'Classic CMS Pages',
    field_name: 'legacy_page',
    slug_plural: 'legacy-pages',
    slug_singular: 'legacy-page'
  },
  unmapped: {
    template_folder: 'pages',
    name: 'unmapped',
    api_slug: 'unmappeds',
    label: 'Unmapped',
    dashboard_slug: 'unmappeds',
    new_content_slug: 'new/unmapped',
    id: 0,
    generic_label: 'System',
    label_plural: 'Unmappeds',
    field_name: 'unmapped',
    slug_plural: 'unmappeds',
    slug_singular: 'unmapped'
  },
  site_page: {
    template_folder: 'site_page',
    name: 'site-page',
    api_slug: 'site-pages',
    label: 'Website Page',
    dashboard_slug: 'site-pages',
    new_content_slug: 'new/site-page',
    id: 4,
    generic_label: 'Website Page',
    label_plural: 'Website Pages',
    field_name: 'site_page',
    slug_plural: 'site-pages',
    slug_singular: 'site-page'
  },
  email: {
    template_folder: 'email',
    name: 'email',
    api_slug: 'emails',
    label: 'Email',
    dashboard_slug: 'email',
    new_content_slug: 'new/email',
    id: 2,
    generic_label: 'Email',
    label_plural: 'Email',
    field_name: 'email',
    slug_plural: 'email',
    slug_singular: 'email'
  },
  'blog-post': {
    template_folder: 'blog',
    name: 'blog-post',
    api_slug: 'blog-posts',
    label: 'Blog Post',
    dashboard_slug: 'blog-posts',
    new_content_slug: 'new/blog-post',
    id: 3,
    generic_label: 'Blog',
    label_plural: 'Blog Posts',
    field_name: 'blog_post',
    slug_plural: 'blog-posts',
    slug_singular: 'blog-post'
  },
  'knowledge-article': {
    template_folder: '',
    name: 'knowledge-article',
    api_slug: '',
    label: 'Knowledge Article',
    dashboard_slug: '',
    new_content_slug: '',
    id: 6,
    generic_label: '',
    label_plural: 'Knowledge Articles',
    field_name: 'knowledge_article',
    slug_plural: 'knowledge-article',
    slug_singular: 'knowledge-articles'
  }
};
exports.default = _default;
module.exports = exports.default;